import React from "react";
import { connect } from "react-redux";
import {
  eventParticipants,
  registryConfiguration,
} from "../../../../../data-store/actions/registry-actions";
import {
  getEventLogs,
  getEventOrganizers,
} from "../../../../../data-store/actions/events-actions";
import AutorizedUsers from "./AutorizedUsers";
import AddAutorizedUser from "./AddAutorizedUser";
import DeletedParticipantNumber from "./DeleteParticipantsTable/DeletedParticipantList";
import ChangesList from "./ChangesTable/ChangesList";
import OrderChangesList from "./ChangesTable/OrderChangesList";
import EventLogsList from "./ChangesTable/EventLogsList";
import DownloadButtomAllData from "../DownloadData/DownloadButtomAllDataNew";
import EventRegistryConfig from "../../../AuthorizedUsers/EventsConfig/EventRegistryConfig";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import GenerateRegistryTemplate from "../ImportData/GenerateRegistryTemplate";
import RegistryImportWizard from "../ImportData/RegistryImportWizard";
import { vistaReportePara } from "../../../../../services/deepLinkRegistry";
import NoveltyInfoButton from "../../../Changelog/NoveltyInfoButton";

class RegistryAuthorizationContainerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vistaReporte: "atletas",
      logsCargados: false,
    };
  }

  componentDidMount() {
    // Deep-link desde el changelog/tooltips (?abrir=tab-autorizaciones-logs):
    // reutiliza setVistaReporte para no duplicar la carga de getEventLogs.
    const vistaPendiente = vistaReportePara(this.props.abrirAnchor);
    if (vistaPendiente) this.setVistaReporte(vistaPendiente);
  }

  setVistaReporte = (vista) => {
    if (vista === "logs" && !this.state.logsCargados) {
      const eventoIndex = "evento_" + this.props.eventDetail.iDEvento;
      this.props.getEventLogs(eventoIndex);
      this.props.getEventOrganizers(eventoIndex);
      this.setState({ logsCargados: true });
    }
    this.setState({ vistaReporte: vista });
  };

  esMasterOMasterOrganizador = () => {
    const { registryAutorizedUsers, userID } = this.props;
    const perfil =
      registryAutorizedUsers &&
      registryAutorizedUsers[userID] &&
      registryAutorizedUsers[userID].perfil;
    return perfil === "master" || perfil === "MasterOrganizador";
  };

  render() {
    console.log(this.props.registryAutorizedUsers);
    return (
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="flex-start"
      >
        <Grid item xs={12} sm={12} style={{ textAlign: "right" }}>
          <NoveltyInfoButton
            anchors={["tab-autorizaciones-importar", "tab-autorizaciones-logs"]}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DownloadButtomAllData
            eventParticipants={this.props.eventParticipants}
            reportType={1}
            eventDetail={this.props.eventDetail}
            registryAutorizedUsers={this.props.registryAutorizedUsers}
            userID={this.props.userID}
            registryConfiguration={this.props.registryConfiguration}
            eventSubEventsRegistry={this.props.eventSubEventsRegistry}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AddAutorizedUser />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AutorizedUsers
            registryAutorizedUsers={this.props.registryAutorizedUsers}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          {this.props.atleteAccount.perfil===1 &&
          <Paper style={{ padding: 20, margin: 5 }}>
            <Typography variant="h5" gutterBottom>
              Sección para importar inscripciones masivas
            </Typography>
            <GenerateRegistryTemplate />
            <RegistryImportWizard />
          </Paper>
          
          }
        </Grid>
        <Grid item xs={12} sm={12}>
          <DeletedParticipantNumber
            eventParticipants={this.props.eventParticipants}
            userID={this.props.userID}
            atleteAccount={this.props.atleteAccount}
            eventDetail={this.props.eventDetail}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <OrderChangesList eventParticipants={this.props.eventParticipants} />
        </Grid>
        <Grid item xs={12} sm={12}>
          <div style={{ margin: 5 }}>
            <Button
              variant={
                this.state.vistaReporte === "atletas" ? "contained" : "outlined"
              }
              color="primary"
              onClick={() => this.setVistaReporte("atletas")}
              style={{ marginRight: 10 }}
            >
              Cambios en atletas
            </Button>
            {this.esMasterOMasterOrganizador() && (
              <Button
                variant={
                  this.state.vistaReporte === "logs" ? "contained" : "outlined"
                }
                color="secondary"
                onClick={() => this.setVistaReporte("logs")}
              >
                Logs del sistema
              </Button>
            )}
          </div>
          {this.state.vistaReporte === "atletas" ? (
            <ChangesList
              eventParticipants={this.props.eventParticipants}
              userID={this.props.userID}
              atleteAccount={this.props.atleteAccount}
              eventDetail={this.props.eventDetail}
            />
          ) : (
            <EventLogsList
              eventLogs={this.props.eventLogs}
              eventOrganizers={this.props.eventOrganizers}
            />
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEventLogs: (eventoIndex) => dispatch(getEventLogs(eventoIndex)),
    getEventOrganizers: (eventoIndex) =>
      dispatch(getEventOrganizers(eventoIndex)),
  };
};

const mapStateToProps = (state) => {
  return {
    eventParticipants: state.registry.eventParticipants,
    eventSubEventsRegistry: state.events.eventSubEventsRegistry,
    registryConfiguration: state.registry.registryConfiguration,
    registryAutorizedUsers: state.registry.registryAutorizedUsers,
    userID: state.atlete.userID,
    eventDetail: state.events.eventDetail,
    atleteAccount: state.atlete.atleteAccount,
    eventLogs: state.events.eventLogs,
    eventOrganizers: state.events.eventOrganizers,
  };
};

const RegistryAuthorizationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistryAuthorizationContainerView);
export default RegistryAuthorizationContainer;
